<!-- 秒杀、摇号的倒计时组件 -->
<template>
  <span>
    <!-- <span v-html="str" class="letter-space-1"></span> -->
    <span v-html="str"></span>
    <span ref="tpl" v-if="showTpl">
      <slot></slot>
    </span>
  </span>
</template>
<script type="text/babel">
  let ydTime = null;
  export default {
    name: 'skyCountdown',
    data() {
      return {
        str: '',
        timer: null,
        tempFormat: '',
        showTpl: true,
        ydTime: undefined,
        addTime: 2,    //延迟的时间（秒），给后台执行进程的时间
        isFirst: true,
        lastTime:null,
      }
    },
    props: {
      time: {
        type: [String, Number, Date]
      },
      format: {
        type: String,
        default: '{%d}天{%h}时{%m}分{%s}秒'
      },
      timetype: {
        validator (value) {
          return ['datetime', 'second'].indexOf(value) > -1;
        },
        default: 'datetime'
      },
      callback: {
        type: Function
      },
      doneText: {
        type: String,
        default: '已结束'
      }
    },
    watch: {
      time(val) {
        console.log("组件中=====："+val)
        if (val && val > 0) {
          this.run();
        }
      },
      $route(val,key) {
        let leftTime = this.lastTime - Math.floor(new Date().getTime() / 1000);
        if (leftTime > 0) {
          this.str = this.timestampTotime(leftTime);
        } else {
          clearInterval(this.ydTime);
        }
      }
    },
    methods: {
      run() {
        // console.log(this.time)
        if (this.time <= 0) return;
        if (this.timetype === 'second') {
          this.lastTime = Math.floor(new Date() / 1000) + ~~this.time + this.addTime;
        } else if (this.time instanceof Date){
          this.lastTime = Math.floor(this.time.getTime() / 1000);
        } else {
          this.lastTime = Math.floor(new Date(this.time).getTime() / 1000);
        }
        //todo:后来加上的，待测试
        clearInterval(this.ydTime);
        this.doRun();
        this.ydTime = setInterval(this.doRun, 1000);
      },
      doRun() {
        let leftTime = this.lastTime - Math.floor(new Date().getTime() / 1000);
        if (leftTime > 0) {
          this.str = this.timestampTotime(leftTime);
        } else {
          clearInterval(this.ydTime);
          this.callback && this.callback()
          this.str = this.doneText;
        }
      },
      timestampTotime(time) {
        let format = this.tempFormat;
        let t = {};
        t.s = time % 60;
        time = Math.floor(time / 60);
        t.m = time % 60;
        time = Math.floor(time / 60);
        t.h = time % 24;
        t.d = Math.floor(time / 24);
        t.dh = t.d*24+t.h;

        const ment = function (a) {
          if (a <= 0)  return '00';
          return a < 10 ? '0' + a : a;
        };
        const arr = ['d','dh', 'h', 'm', 's'];
        arr.forEach((val) => {
          const day = ment(t[val]).toString().split('');
          format = format.replace('{%' + val + '}', ment(t[val]));
          format = format.replace('{%' + val + '0}', ~~day[0] != 0 ? day[0] : '');
          format = format.replace('{%' + val + '1}', ~~day[day.length - 2]);
          format = format.replace('{%' + val + '2}', ~~day[day.length - 1]);
        });
        return format;
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tempFormat = !!this.$slots.default ? this.$refs.tpl.innerHTML : this.format;
        this.showTpl = false;
        this.run();
      });
    },
    activated(){
        //再次进入的时候不用重新启动倒计时，因为在上面的watch中，监听到了，如果time改变了并且不小于0就启动倒计时
        //todo:如果页面的上到倒计时是固定不变的，又需要启动倒计时，就要做这个操作，不过应该不会有这么变态的动作
        // this.run();
    },
    beforeDestroy() {
      clearInterval(ydTime);
      clearInterval(this.ydTime);
    },
    //因为开了缓存，这里在子组件离开的时候一定要清除倒计时
    deactivated () {
      clearInterval(ydTime);
      clearInterval(this.ydTime);
    },
  }
</script>
<style lang="less" scoped>
  .letter-space-1{
     letter-spacing: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/countdown/countdownd.vue